import { useContext } from 'react';
import { Portal } from '@trinity/chat-components/components/Portal/index.js';
import { FileUploadsStateContext } from '@trinity/chat-components/containers/WorkspaceFileUpload/Context';
import FileUpload from './FileUpload';
import Header from './Header';
import { useRootStyles } from './hooks/useRootStyles';
import InvalidFile from './InvalidFile';
import styles from './style/FileUploadsProgress.module.css';

export const FileUploadsProgress = () => {

  const state = useContext(FileUploadsStateContext);
  const style = useRootStyles();

  return (
    <Portal>
      <div className={styles.root} style={style}>
        <Header />
        <div className={styles.items}>
          {state.valid.map(m => <FileUpload key={m.id} fileUpload={m} />)}
          {state.invalid.map((m, i) => <InvalidFile key={i} {...m} />)}
        </div>
      </div>
    </Portal>
  );
};

export default FileUploadsProgress;